import React from 'react'
import _ from 'underscore'
import { Info, SlidersHorizontal } from 'lucide-react'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import FieldRow from '../../../field_row'
import PillSelect from '../../../pill_select'
import store from '../../../../state/store'

class CustomerPreferences extends React.Component {

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.lesson_plan !== this.props.lesson_plan) return true
    if (nextProps.enquiry_id !== this.props.enquiry_id) return true
    if (nextState !== this.state) return true
    return false
  }

  update = (params) => {
    store.emit('enquiry:lesson_plans:update', this.props.enquiry_id, this.props.lesson_plan.id, params)
  }

  updateSettings = (params) => {
    store.emit('tutoring_jobs:update_settings', this.props.lesson_plan.tutoring_job.id, params)
  }

  render() {
    const lp = this.props.lesson_plan
    const tj = lp.tutoring_job

    const learnerDisplay = {}
    for (let i = 1; i <= 10; i++) learnerDisplay[String(i)] = i + (i === 1 ? ' Learner' : ' Learners')

    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <SlidersHorizontal className="size-4" />
            Customer Preferences
          </CardTitle>
        </CardHeader>
        <CardContent>
          <FieldRow label="Budget">
            <PillSelect options={lp.budget_options} value={tj.settings.budget} onChange={(v) => this.updateSettings({budget: v})} />
          </FieldRow>

          <FieldRow label="Learners / Lesson" last>
            <PillSelect
              numeric
              options={_.map([1,2,3,4,5,6,7,8,9,10], (n) => ({value: n, name: String(n)}))}
              value={lp.learners_per_lesson}
              displayMap={learnerDisplay}
              onChange={(v) => this.update({learners_per_lesson: v})}
            />
          </FieldRow>
          <div className="mt-4">
            <span className="inline-flex items-center rounded-full bg-muted px-3.5 py-1.5 text-[13px] text-muted-foreground">
              <Info className="mr-2 size-3.5"/>
              Client preferences have moved to the Tutor tab.
            </span>
          </div>
        </CardContent>
      </Card>
    )
  }
}

export default CustomerPreferences
